module.exports = __webpack_public_path__ + "static/media/entrenador-digital.0336b182.svg";